module.exports = __webpack_public_path__ + "media/contacts.bb3466e2.mp4";